import { Button, Heading, Stack, Text } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router'
import { ActionBar } from '~/components/member/ActionBar'
import { MemberLayout } from '~/components/member/layout'
import { useT } from '~/i18n/use-t'

/** S0 "link not active": the provider of this link is turned off. */
export default function LinkNotActive({ defaultJoinPath }: { defaultJoinPath: string }) {
  const { t } = useT()
  return (
    <MemberLayout>
      <Stack gap={4}>
        <Heading as='h1' size={{ base: '2xl', md: '3xl' }}>
          {t('notActive.title')}
        </Heading>
        <Text>
          {t('notActive.instead')}{' '}
          <Text as='span' overflowWrap='anywhere'>
            {window.location.host}
            {defaultJoinPath}
          </Text>
        </Text>
        <ActionBar>
          <Button asChild size='lg' w='full'>
            <RouterLink to={defaultJoinPath}>{t('notActive.go')}</RouterLink>
          </Button>
        </ActionBar>
      </Stack>
    </MemberLayout>
  )
}
